export default __webpack_public_path__ + "static/media/ysd-008-setu2.a9e37b57.jpg";